// Types
import { IShareUrlsNames } from 'types'
interface IShareUrls {
  facebook: string
  twitter: string
  telegram: string
  instagram: string
  whatsapp: string
  vk: string
}

const shareUrls: IShareUrls = {
  facebook: 'https://www.facebook.com/sharer.php?s=',
  twitter: 'https://twitter.com/intent/tweet?url=',
  instagram: 'https://www.instagram.com/',
  telegram: 'https://t.me/share/url?url=',
  vk: 'https://vk.com/share.php?url=',
  whatsapp: 'https://api.whatsapp.com/send/?type=custom_url&app_absent=0&text=',
}

export default function shareVia(platform: IShareUrlsNames, url: string): void {
  const shareUrl: string = shareUrls[platform]
  if (!shareUrl) return

  const fullUrl: string = shareUrl + encodeURIComponent(url) + '&title=' + encodeURIComponent('Amazing Product') + '&text=' + encodeURIComponent('Check out this amazing product I found!')
  window.open(fullUrl, '_blank')
}